import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const restoreRuleSet = api(async function restoreRuleSet({ id }) {
    return mutate(
        gql`
            mutation RestoreRuleSet($id: String!) {
                restoreRuleSet(id: $id)
            }
        `,
        { id },
        { returns: "restoreRuleSet" }
    )
})
